import { createAction } from '@reduxjs/toolkit';

export const editFilterPageActions = {
  navigateTo: createAction<{ navigateTo: string }>('EditFilterPage/NavigateTo'),
  errorNotification: createAction<{ customMessage: string }>('EditFilterPage/ErrorNotification'),
};
